module.exports = __webpack_public_path__ + "img/service-qrcode2.20060af3.png";